import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { EventsVService } from 'src/api/v2';
import { useCluster } from 'src/features/cluster';

import { EVENT_PARTICIPANTS_KEY } from 'src/constants/hook-keys';

export default function useEventParticipants(eventId: string) {
  const { cluster } = useCluster();

  const [service] = useState(new EventsVService());

  const { data, ...rest } = useQuery({
    queryKey: [EVENT_PARTICIPANTS_KEY, eventId],
    queryFn: () => service.getEventParticipants(eventId),
    enabled: !!cluster && !!eventId,
  });

  return {
    eventParticipants: data || [],
    ...rest,
  };
}
